"use strict";

var crypto = require("crypto");
var EC = require("elliptic").ec;
var ec = new EC("secp256k1");
var bigInt = require("big-integer");

var sha256 = exports.sha256 = function (data) {
  return crypto.createHash("sha256").update(data).digest();
};

var hash = exports.hash = function (object) {
  return sha256(sha256(JSON.stringify(object)));
};

var merkleHash = exports.merkleHash = function (list) {
  if (list.length === 1) {
    return hash([list[0], list[0]]);
  } else if (list.length === 2) {
    return hash([list[0], list[1]]);
  } else {
    var center = Math.floor(list.length / 2);
    return hash([merkleHash(list.slice(0, center)), merkleHash(list.slice(center))]);
  }
};

exports.sign = function (data, privateKey) {
  var key = ec.keyFromPrivate(privateKey, "hex");
  return key.sign(hash(data)).toDER();
};

exports.verify = function (data, publicKey, signature) {
  var key = ec.keyFromPublic(publicKey, "hex");
  return key.verify(hash(data), signature);
};

exports.generatePrivateKey = function () {
  return ec.genKeyPair().getPrivate().toString("hex");
};

exports.getPublicKey = function (privateKey) {
  return ec.keyFromPrivate(privateKey).getPublic().encode("hex");
};

var validateProofOfWork = exports.validateProofOfWork = function (hash, target) {
  if (typeof target === "string") {
    target = bigInt(target, 16);
  }
  return bigInt(hash.toString("hex"), 16).lt(target);
};

exports.mine = function (block) {
  var maxTries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;

  block.nonce = 0;
  while (maxTries--) {
    block.time = Date.now();
    block.nonce = (block.nonce + 1) % Number.MAX_SAFE_INTEGER;
    if (validateProofOfWork(hash(block), block.target)) {
      return block;
    }
  }
  return null;
};

exports.stripTxSignatures = function (tx) {
  tx = JSON.parse(JSON.stringify(tx)); // HACK: deep clone
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = tx.inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var input = _step.value;

      delete input.scriptSig;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return tx;
};


//////////////////
// WEBPACK FOOTER
// ../lib/util.js
// module id = 179
// module chunks = 0